<template>
  <a-spin :spinning="isLoading" tip="Please wait...">
    <div class="mb-3">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <div class="row mb-3">
                <div class="col-md-12">
                  <h3 class="mb-0">Bulk Member Tag</h3>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <h6 class="heading-small text-muted">
                        <span class="text-danger">*</span> Membership Program
                      </h6>
                      <a-select
                        placeholder="Select membership program"
                        style="width: 100%"
                        v-model="formData.membership_program_id"
                        :disabled="viewMode"
                        @change="onChangeMembershipProgram"
                      >
                        <a-select-option
                          v-for="membershipProgram in options.membershipPrograms"
                          :key="membershipProgram.id"
                          :value="membershipProgram.id"
                        >
                          {{ membershipProgram.name }}
                        </a-select-option>
                      </a-select>
                      <div
                        v-if="$v.formData.membership_program_id.$dirty"
                        class="text-danger"
                      >
                        <div
                          class="error"
                          v-if="!$v.formData.membership_program_id.required"
                        >
                          Field is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col">
                      <h6 class="heading-small text-muted">
                        <span class="text-danger">*</span> Upload File
                      </h6>
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <a-input
                            placeholder="Member Name"
                            v-model="formData.csv"
                            type="file"
                            accept=".csv"
                            class="custom-file-input"
                            id="inputGroupFile01"
                            @change="handleFileChange"
                          />
                          <label
                            class="custom-file-label"
                            for="inputGroupFile01"
                            >{{ selectedFileName }}</label
                          >
                        </div>
                      </div>
                      <small class="text-muted" v-if="!viewMode">
                        File must be in csv file format. Download template
                        <a href="#" @click="downloadTemplate">here</a>.
                      </small>
                      <div v-if="$v.formData.csv.$dirty" class="text-danger">
                        <div class="error" v-if="!$v.formData.csv.required">
                          Field is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end">
                    <div class="p-1">
                      <b-button
                        size="sm"
                        class="float-md-left"
                        style="margin-left: 8px"
                        @click.prevent="closeDrawer"
                      >
                        Cancel
                      </b-button>
                    </div>
                    <div class="p-1">
                      <b-button
                        size="sm"
                        @click="confirmAdjustment"
                        variant="success"
                      >
                        <b-spinner v-if="submitLoading" small></b-spinner>
                        Import
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import secureStorage from '../../controllers/secureStorage';
import { Modal } from 'ant-design-vue';
import axios from 'axios';
const S3Api = process.env.VUE_APP_BXI_S3_API;

export default {
  name: 'BulkMemberTagForm',
  props: {
    memberTagData: Object,
    viewMode: Boolean,
    type: String,
    drawerVisible: Boolean
  },
  components: {},
  data() {
    return {
      isLoading: false,
      selectedFileName: 'Choose file',
      searchLoading: false,
      submitLoading: false,
      query: null,
      querySuccess: false,
      transactionFlag: false,
      searchPlaceHolder: 'Card number',
      example: 'Card Number (e.g. 100000234567)',
      formData: {
        membership_program_id: null,
        csv: null
      },
      options: {
        membershipPrograms: []
      }
    };
  },

  validations: {
    formData: {
      membership_program_id: { required },
      csv: { required }
    }
  },

  methods: {
    closeDrawer() {
      this.resetData();
      this.$emit('closeDrawer', null);
    },
    onChangeMembershipProgram() {
      this.formData.adjustment_reason_type_id = null;
      this.getAdjustmentReasonTypes(this.formData.membership_program_id);
    },
    confirmAdjustment() {
      Modal.confirm({
        title: 'Confirm',
        content:
          'Are you sure you want to proceed with the bulk member tag adjustment? This action cannot be reverted and processing may take a while.',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => {
          this.onSubmit(); // Proceed with the points adjustment
        },
        onCancel: () => {
          // Do nothing, user canceled
        }
      });
    },
    validateCsvHeaders(headers) {
      const requiredHeaders = ['member_id', 'membership_level', 'member_tags'];
      for (const header of requiredHeaders) {
        if (!headers.includes(header)) {
          return false;
        }
      }
      return true;
    },
    validateCsvRows(lines, headers) {
      // const requiredFields = ['member_id', 'membership_level', 'member_tags'];

      for (let i = 1; i < lines.length; i++) {
        const row = lines[i].split(',').map((field) => field.trim());
        if (row.length === 1 && row[0] === '') continue;

        const rowObj = {};
        headers.forEach((header, idx) => {
          rowObj[header] = row[idx] || '';
        });

        // Required Fields Check
        // for (const field of requiredFields) {
        //   if (!rowObj[field] || rowObj[field].trim() === '') {
        //     throw new Error(`Row ${i + 1}: "${field}" cannot be empty.`);
        //   }
        // }
      }

      return true;
    },
    handleFileChange(event) {
      const fileInput = event.target;
      if (fileInput.files.length > 0) {
        const selectedFile = fileInput.files[0];
        this.selectedFileName = selectedFile.name;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.isLoading = true;
          try {
            const contents = e.target.result;
            const lines = contents.split('\n');
            if (lines.length > 0) {
              const headers = lines[0]
                .split(',')
                .map((header) => header.trim());

              if (!this.validateCsvHeaders(headers)) {
                this.selectedFileName = 'Choose file';
                this.formData.csv = null;

                throw new Error(
                  'Missing header on uploaded file. CSV headers must include member_id, membership_level, and member_tags.'
                );
              }

              this.validateCsvRows(lines, headers);
            }
          } catch (err) {
            this.selectedFileName = 'Choose file';
            this.formData.csv = null;
            this.$notification.error({
              message: err?.message ?? err
            });
          } finally {
            this.isLoading = false;
          }
        };

        this.formData.data = selectedFile;
        reader.readAsText(selectedFile);
      } else {
        this.selectedFileName = 'Choose file';
      }
    },
    downloadTemplate() {
      const csvContent = 'member_id,membership_level,member_tags';
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'Bulk Member Tag Template.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    moment,
    setTransactionFlag(el) {
      const positiveFlag = el.item.$el.dataset.positiveFlag == 1 ? true : false;
      this.transactionFlag = positiveFlag;
    },

    async s3Upload(file = []) {
      if (file && file.length > 0 && file[0] instanceof File) {
        console.log('Uploading to S3');
        const formData = new FormData();
        formData.append('file', file[0]);
        let filePath = null;
        try {
          const upload = await axios({
            method: 'POST',
            url:
              S3Api +
              '?account_name=' +
              this.accountName +
              '&profile=app-notification-image',
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem('uploadToken')
            },
            data: formData
          });

          if (typeof upload.data.path !== 'undefined' && upload.data.path) {
            console.log('File uploaded');
            filePath = upload.data.path;
          } else {
            console.log('No upload path');
            this.$message.error('Unable to upload image. Please try again!');
          }

          return filePath;
        } catch (err) {
          this.$message.error('Unable to upload image. Something went wrong!');
          throw err;
        }
      }

      return null;
    },

    async onSubmit() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.submitLoading = true;
        const formData = new FormData();
        formData.append(
          'membership_program_id',
          this.formData.membership_program_id
        );
        formData.append('csv', this.formData.data);

        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_members/member_tags/bulk?origin_site_id=' +
            secureStorage.getItem('currentSiteId'),
          formData,
          secureStorage.getItem('bxiClpAccessToken'),
          'multipart/form-data'
        );

        if (response.message != undefined && response.message == 'Success') {
          this.$emit('closeDrawer', null);
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Import completed.'
          });

          this.resetData();
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.submitLoading = false;
      }
    },

    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs',
        { per_page: 1000 }
      );
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      this.formData.membership_program_id = response.data[0].id;
    },
    resetData() {
      this.formData = {
        membership_program_id: null,
        csv: null
      };
      this.selectedFileName = 'Choose file';
      this.query = null;
      this.querySuccess = false;
      this.$v.formData.$reset();
    }
  },

  created() {
    this.getMembershipPrograms();
  },

  computed: {
    accountName() {
      return this.$store.getters.getAccount?.account_name ?? null;
    }
  },
  watch: {
    memberTagData: function (data) {
      this.setFormData(data);
    }
  }
};
</script>

<style scoped></style>
